/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Popover, Position, Size, Tooltip } from "@blueprintjs/core" 
import { useEffect, useRef, useState } from "react"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import updateHistory from "../utils/updateHistory"
import { ID, POST_STATUS } from "src/libs/interfaces/layouts"
import updateSection from "../utils/updateSection"
import { Hint } from "src/libs/useful"

const ITEM_EDITABLE_TYPES: any[] = [
    {
        type: LANDING_TYPE_CONTENT.CARDS,
        itemsName: "cards",
    },
    {
        type: LANDING_TYPE_CONTENT.BUTTONS,
        itemsName: "buttons",
    },
    {
        type: LANDING_TYPE_CONTENT.LINKS_FEED,
        itemsName: "items",
    },
    {
        type: LANDING_TYPE_CONTENT.PASSAGE,
        itemsName: "items",
    },
]
/* Protopia Ecosystem component */
export interface IItemEditorProps {
   item: any
   items: any[]
   i: number
   type: string
   onAdd?: (sectionId: ID) => void
   onEdit?: (sectionId: ID) => void
}
const ItemEditor = (props: IItemEditorProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)
    const currentLanding                = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const [ sectionId, setSectionId ]   = useState<string>("")
    const [ dataId, setDataId ]         = useState<string>("") 

    useEffect(() => {
        const par = ref.current! as HTMLDivElement
        setSectionId( par.closest(".landing-section-container.landing-gap")?.getAttribute("id") || "" )
        setDataId( par.closest(`[data-type="${props.type}"][data-content-id]`)?.getAttribute("data-content-id") || "" )
    }, []) 
    
    const duplicate = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Duplicate card"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const items: any[] = data.items
                            const newItem = {
                                id: getID( data.type ), 
                                src: props.item.data.src
                            }
                            items.splice( props.i, 0,newItem )
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    } 
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing )
    }

    const doDelete = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Delete card"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            if( !ITEM_EDITABLE_TYPES.map(i => i.type).includes( data.type )) {
                                return data
                            }
                            if(data.id === dataId) {
                                 const tp = ITEM_EDITABLE_TYPES.find( i => i.type === props.type ).itemsName || "items"
                                const items: any[] = data[ tp ]
                                items.splice( props.i, 1 ) 
                                return { ...data, [tp]: items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing )
    }
    const onPrev = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Switch cards"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if( s.id === sectionId ) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data 
                         .map((data: any) => {
                            if( !ITEM_EDITABLE_TYPES.map(i => i.type).includes( data.type )) {
                                return data
                            }
                            if(data.id === dataId) {
                                const tp = ITEM_EDITABLE_TYPES.find( i => i.type === props.type ).itemsName || "items"
                                const items: any[] = data[ tp ]
                                const newItems = items.splice( props.i, 1 ) 
                                items.splice( props.i - 1, 0, newItems[0] ) 
                                return { ...data, [tp]: items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing )
    }
    const onNext = () => {
        const section = currentLanding.sections.find((s: ILandingSection) => s.id === sectionId)
        const meat = section?.data.find((data: any) => data.id === dataId)
        const prevData = JSON.parse(JSON.stringify( section ))
        const newSection =   {
            ...section,
            data: section.data.map((data: any) => {
                if( !ITEM_EDITABLE_TYPES.map(i => i.type).includes( data.type )) {
                    return data
                }
                if(data.id === dataId) {
                    const tp = ITEM_EDITABLE_TYPES.find( i => i.type === props.type ).itemsName || "items"
                    const items: any[] = data[ tp ]
                    const newItems = items.splice( props.i, 1 ) 
                    items.splice( props.i + 1, 0, newItems[0] ) 
                    return { ...data, [tp]: items }
                }
                return data
            })
        }
        const step: IHistoryStep = {
            prevData,
            data: newSection,
            type: HISTORY_TYPE.SECTION,
            title : "Switch items (" + meat?.type + ")"
        }
        updateSection( newSection, step )
    }
    const onAdd = (value: string ) => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Add new cards"
        }
        
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((s: ILandingSection) => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data =  {
                        ...s,
                         data: s.data.map((data: any) => {
                            const items: any[] = data.items 
                            const newItem = {
                                id: getID("image"), 
                                src: value
                            }
                            items.splice( props.i + 1, 0, newItem ) 
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing )
    } 
    const onStatus = () => {
        const section = currentLanding.sections.find((s: ILandingSection) => s.id === sectionId)
        const meat = section?.data.find((data: any) => data.id === dataId)
        const prevData = JSON.parse(JSON.stringify( section ))
        const newSection =   {
            ...section,
            data: section.data.map((data: any) => {
                if( !ITEM_EDITABLE_TYPES.map(i => i.type).includes( data.type )) {
                    return data
                }
                if(data.id === dataId) {
                    const tp = ITEM_EDITABLE_TYPES.find( i => i.type === props.type ).itemsName || "items" 
                    const items: any[] = data[ tp ].map(( item: any, i: number ) => ({
                        ...item,
                        status: i === props.i
                            ? 
                            item.status === POST_STATUS.PUBLISH ? POST_STATUS.DRAFT : POST_STATUS.PUBLISH 
                            : 
                            item.status
                    }))
                    return { ...data, [tp]: items }
                }
                return data
            })
        }
        const step: IHistoryStep = {
            prevData,
            data: newSection,
            type: HISTORY_TYPE.SECTION,
            title : "Switch item's status' (" + meat?.type + ")"
        }
        updateSection( newSection, step )
    }

    const ICON_SIZE = 12
    return <div className='pe-item-editor pe-surface' ref={ref} data-select-type="ignore">
        {
            props.i > 0 && <Hint label={__("Switch previous")} >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID}  onClick={onPrev}>
                    <Icon icon="arrow-left" size={ICON_SIZE} />
                </Button>
            </Hint>
        } 
        <Hint label={__("Edit")} >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={() => props.onEdit( sectionId) }>
                <Icon icon="edit" size={ICON_SIZE} />
            </Button>
        </Hint>
        <Hint label={__("Add after")} >
           { 
                props.onAdd
                    ?
                    <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={() => props.onAdd( sectionId ) }>
                        <Icon icon="plus" size={ICON_SIZE} />
                    </Button>
                    :
                    <Popover
                        content={ <AddItem onAdd={ onAdd } /> }
                    >
                        <Button size={Size.SMALL} variant={ButtonVariant.SOLID} >
                            <Icon icon="plus" size={ICON_SIZE} />
                        </Button>
                    </Popover>
            }
        </Hint>
        {
            props.type === LANDING_TYPE_CONTENT.LINKS_FEED && <Hint label={__( props.item?.status )} >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID}  onClick={ onStatus }>
                    <Icon icon={ props.item?.status === POST_STATUS.PUBLISH ? "eye-open" : "eye-off" } size={ ICON_SIZE } />
                </Button>
            </Hint>
        } 
        <Hint label={__("Delete")}  >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={doDelete}>
                <Icon icon="trash" size={ICON_SIZE} />
            </Button>
        </Hint>
        {
            props.i < props.items.length - 1 && <Hint label={__("Switch next")} >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={onNext}>
                    <Icon icon="arrow-right" size={12} />
                </Button>
            </Hint>
        }
    </div>
}
export default ItemEditor

export const AddItem = ({ onAdd }: any) => {
    const [value, setValue] = useState<any>("")
    return <div className="p-3">
        <FieldInput
            type={SCALAR_TYPES.MEDIA}
            editable
            value={value}
            onChange={(val: any) => setValue(val)}
        />
        <Button onClick={ () => onAdd( value ) } >
            {__("Add new item")}
        </Button>
    </div>
}